import request from "@/utils/request";

// 列表
export function getList(data) {
  return request({
    // url: "/api/member/get",
    url: "/api/member",
    method: "post",
    data,
  });
}
// 添加
export function addItem(data) {
  return request({
    url: "/api/member/add",
    method: "post",
    data,
  });
}
// 编辑
export function editItem(id, data) {
  return request({
    url: "/api/member/update",
    method: "post",
    data: { id, ...data },
  });
}
// 删除
export function delItem(data) {
  return request({
    url: "/api/member/delete",
    method: "post",
    data,
  });
}
// 会员查询
export function getCert(data) {
  return request({
    // url: "/api/cert/get",
    url: "/api/cert",
    method: "post",
    data,
  });
}